export default "__VITE_ASSET__0725c42f__"